var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useRef } from 'react';
import { sleep } from '@/utils/async/sleep';
import { ANIMATION_TIME_MOVING } from '@/utils/constants/ui/driver';
/**
 * Driver イベント制御
 */
export const useDriverEvent = (options) => {
    const { activeIndex, changeActiveIndex, changeTransition, hideTooltip, scrollToTarget, settings, showTooltip, stop, unmountRef, updateStyle, } = options;
    /** 最後の処理のみ実行されるよう判定用のId管理 */
    const animationRef = useRef(null);
    /**
     * 次の要素に移動
     */
    const onChangeNext = useCallback((nextIndex) => __awaiter(void 0, void 0, void 0, function* () {
        const animationId = new Date();
        animationRef.current = animationId;
        // ツールチップ非表示+アニメーション スタイル付与
        hideTooltip();
        changeTransition(`clip-path ${ANIMATION_TIME_MOVING}ms`);
        yield sleep(0);
        // 要素移動
        if (animationRef.current === animationId) {
            changeActiveIndex(nextIndex);
            updateStyle(settings[nextIndex].ref);
            scrollToTarget(nextIndex);
        }
        // アニメーションの移動時間分待つ
        yield sleep(ANIMATION_TIME_MOVING);
        // ツールチップ表示+アニメーション スタイル削除
        if (animationRef.current === animationId && !unmountRef.current) {
            changeTransition(undefined);
            showTooltip();
        }
    }), [
        animationRef,
        changeActiveIndex,
        changeTransition,
        hideTooltip,
        scrollToTarget,
        settings,
        showTooltip,
        unmountRef,
        updateStyle,
    ]);
    /**
     * 対象要素の変更
     */
    const onChangeTarget = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        const nextIndex = activeIndex + 1;
        const lastIndex = settings.length - 1;
        // 次の Step がある場合 次に移動
        if (nextIndex <= lastIndex) {
            onChangeNext(nextIndex);
            (_b = (_a = settings[activeIndex]).onDeselect) === null || _b === void 0 ? void 0 : _b.call(_a);
            return;
        }
        // 次の Step がない場合 終了
        stop();
    }), [activeIndex, onChangeNext, settings, stop]);
    /**
     * オーバーレイ クリック時のイベント
     */
    const onClickOverlay = useCallback(() => {
        var _a, _b;
        (_b = (_a = settings[activeIndex]).onClickOverlay) === null || _b === void 0 ? void 0 : _b.call(_a);
    }, [settings, activeIndex]);
    return {
        onChangeTarget,
        onClickOverlay,
    };
};
